import { takeLatest } from "redux-saga/effects";
import * as actionTypes from "./actionTypes";
import {
  addSupplierSaga,
  editSupplierSaga,
  deleteSupplierSaga,
  getSuppliersSaga
} from "./saga";

export default function* watchSupplier() {
  yield takeLatest(actionTypes.ADD_SUPPLIER, addSupplierSaga);
  yield takeLatest(actionTypes.EDIT_SUPPLIER, editSupplierSaga);
  yield takeLatest(actionTypes.DELETE_SUPPLIER, deleteSupplierSaga);
  yield takeLatest(actionTypes.GET_SUPPLIERS, getSuppliersSaga);
}